'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.AvatarTypes = void 0;
(function(AvatarTypes) {
    AvatarTypes["Bauhaus"] = 'bauhaus';
    AvatarTypes["Beam"] = 'beam';
    AvatarTypes["Marble"] = 'marble';
    AvatarTypes["Pixel"] = 'pixel';
    AvatarTypes["Ring"] = 'ring';
    AvatarTypes["Sunset"] = 'sunset';
})(exports.AvatarTypes || (exports.AvatarTypes = {}));
//# sourceMappingURL=avatar.js.map
